/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { SysquePopupConfig } from '../models/sysque-popup-config';
import { AboutDialog } from './dialogs/about-dialog';
import { ImportScheduleDialog } from './dialogs/import-schedule-dialog';
import { PanelDialog } from './dialogs/paneldata-dialog';
import { PopupDialog } from './popup-dialog.interface';
import { CreateSystemCategoryDialog } from './dialogs/create-system-category-dialog';
import { RenameSystemCategoryDialog } from './dialogs/rename-system-category-dialog';
import { DeleteSystemCategoryDialog } from './dialogs/delete-system-category-dialog';
import { ConfigurationLocationDialog } from './dialogs/configuration-location-dialog';
import { PlaceCouplingDialog } from './dialogs/place-coupling-dialog';
import { CovertSystemDialog } from './dialogs/convert-system-dialog';
import { ApplyConduitIdDialog } from './dialogs/apply-conduit-id-dialog';
import { ApplyEquipmentIdDialog } from './dialogs/apply-equipment-id-dialog';
import { AddFittingsDialog } from './dialogs/add-fittings-dialog';
import { ElectricalSettingsDialog } from './dialogs/electrical-settings-dialog';
import { AnnotationSettingsDialog } from './dialogs/annotation-settings-dialog';
import { CableTrayFamilyInformationDialog } from './dialogs/cable-tray-family-information-dialog';
import { FieldFabFamilyInformationDialog } from './dialogs/field-fab-family-information';
import { SystemManagerDialog } from './dialogs/system-manager-dialog';
import { ProjectDataDialog } from './dialogs/project-data-dialog';
import { ImportSystemsDialog } from './dialogs/import-systems-dialog';
import { DuplicateSystemCategoryDialog } from './dialogs/duplicate-system-dialog';
import { ConduitFamilyInformationDialog } from './dialogs/conduit-family-information-dialog';
import { AssignProjectDialog } from './dialogs/assign-project-dialog';
import { JunctionBoxFamilyInformationDialog } from './dialogs/junction-box-family-information-dialog';
import { AddNewProjectParameterDialog } from './dialogs/add-project-parameter-dialog';
import { FittingPrioritizationDialog } from './dialogs/fitting-prioritization-dialog';
import { HandAndMachineBendFamilyInformationDialog } from './dialogs/hand-and-machine-bend-family-information-dialog';
import { SysQueGaugeDialog } from './dialogs/sysque-gauge-dialog';
import { KickHandAndMachineBendFamilyInformationDialog } from './dialogs/kick-hand-and-machine-bend-family-information-dialog';
import { UserCustomContentFamilyInformationDialog } from './dialogs/user-custom-content-family-information-dialog';
import { DeviceEquipmentFamilyInformationDialog } from './dialogs/device-equipment-family-information-dialog';
import { HangerSpecificationFamilyInformationDialog } from './dialogs/hanger-specification-family-information-dialog';

export abstract class PopupDialogCreator {
  public abstract createDialog(sysquePopupConfig: any, componentTitle?: string): PopupDialog;
}

//Create an instance for AboutDialog
export class AboutDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new AboutDialog().create(sysquePopupConfig);
  }
}

//Create an instance for ImportScheduleDialog
export class ImportScheduleDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new ImportScheduleDialog().create(sysquePopupConfig);
  }
}

//Create an instance for CreateSystemCategoryDialog
export class CreateSystemCategoryDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig, componentTitle?: string): PopupDialog {
    return new CreateSystemCategoryDialog().create(sysquePopupConfig, componentTitle);
  }
}

//Create an instance for RenameSystemCategoryDialog
export class RenameSystemCategoryDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig, componentTitle?: string): PopupDialog {
    return new RenameSystemCategoryDialog().create(sysquePopupConfig, componentTitle);
  }
}

//Create an instance for DeleteSystemCategoryDialog
export class DeleteSystemCategoryDialogCreator extends PopupDialogCreator {
    public createDialog(sysquePopupConfig: SysquePopupConfig, componentTitle?: string): PopupDialog {
        return new DeleteSystemCategoryDialog().create(sysquePopupConfig, componentTitle);
    }
}

//Create an instance for DuplicateSystemCategoryDialog
export class DuplicateSystemCategoryDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig, componentTitle?: string): PopupDialog {
    return new DuplicateSystemCategoryDialog().create(sysquePopupConfig, componentTitle);
  }
}

//Create an instance for PanelDataDialog
export class PanelDataDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new PanelDialog().create(sysquePopupConfig);
  }
}

//Create an instance for ConfigurationLocationDialog
export class ConfigurationLocationDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new ConfigurationLocationDialog().create(sysquePopupConfig);
  }
}

//Create an instance for PlacecouplingDialog
export class PlaceCouplingDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new PlaceCouplingDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Convert System Dialog
export class ConvertSystemDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new CovertSystemDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Apply Conduit Id Dialog
export class ApplyConduitIdDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new ApplyConduitIdDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Apply Equipment Id Dialog
export class ApplyEquipmentIdDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new ApplyEquipmentIdDialog().create(sysquePopupConfig);
  }
}

//Create an instance for add fittings Dialog
export class AddFittingsDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new AddFittingsDialog().create(sysquePopupConfig);
  }
}

//Create an instance for SysQue Settings Dialog
export class ElectricalSettingsDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new ElectricalSettingsDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Annotation Settings Dialog
export class AnnotationSettingsDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new AnnotationSettingsDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Cable Tray Family Information Dialog
export class CableTrayFamilyInformationDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new CableTrayFamilyInformationDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Conduit Family Information Dialog
export class ConduitFamilyInformationDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new ConduitFamilyInformationDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Junction Box Family Information Dialog
export class JunctionBoxFamilyInformationDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new JunctionBoxFamilyInformationDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Field Fab Family Information with diagram Dialog
export class FieldFabFamilyInformationDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new FieldFabFamilyInformationDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Hand and Machine Bend Family Information with diagram Dialog
export class HandAndMachineBendFamilyInformationDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new HandAndMachineBendFamilyInformationDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Kick Hand and Machine Bend Family Information with diagram Dialog
export class KickHandAndMachineBendFamilyInformationDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new KickHandAndMachineBendFamilyInformationDialog().create(sysquePopupConfig);
  }
}

//Create an instance for User Custom Content Family Information with diagram Dialog
export class UserCustomContentFamilyInformationDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new UserCustomContentFamilyInformationDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Device Equipment Family Information with diagram Dialog
export class DeviceEquipmentFamilyInformationDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new DeviceEquipmentFamilyInformationDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Hanger Specification Family Information with diagram Dialog
export class HangerSpecificationFamilyInformationDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new HangerSpecificationFamilyInformationDialog().create(sysquePopupConfig);
  }
}

//Create an instance for System Manager Dialog
export class SystemManagerDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new SystemManagerDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Add New Project data Dialog
export class ProjectDataDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new ProjectDataDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Import Systems Dialog
export class ImportSystemsDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new ImportSystemsDialog().create(sysquePopupConfig);
  }
}

//Create an instance for Assign Parameters Dialog
export class AssignProjectDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new AssignProjectDialog().create(sysquePopupConfig);
  }
}
export class AddNewProjectParameterDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new AddNewProjectParameterDialog().create(sysquePopupConfig);
  }
}

export class FittingPrioritizationDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new FittingPrioritizationDialog().create(sysquePopupConfig);
  }
}

export class SysQueGaugeDialogCreator extends PopupDialogCreator {
  public createDialog(sysquePopupConfig: SysquePopupConfig): PopupDialog {
    return new SysQueGaugeDialog().create(sysquePopupConfig);
  }
}